import { FieldType, Schema } from "../../../../hooks/useSchema";

export const EditFootnoteCommand = "cms.footnote.edit";

export const FootnotePropsSchema: Schema = {
  footnote_text: { type: FieldType.textlong, label_id: "powerdoc.plugins.footnote.footnote_text"},
  label: { type: FieldType.text, label_id: "powerdoc.plugins.footnote.label"},
}